import { render } from "./portfolio.vue?vue&type=template&id=e4473606&scoped=true"
import script from "./portfolio.vue?vue&type=script&lang=js"
export * from "./portfolio.vue?vue&type=script&lang=js"

import "./portfolio.vue?vue&type=style&index=0&id=e4473606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4473606"]])

export default __exports__